var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropList01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.517 140.074 16 16",
    enableBackground: "new 78.517 140.074 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M90.517,145.074h-9v1h9V145.074z M86.517,148.074h-5v1h5V148.074z M88.517,151.074h-7v1h7V151.074z  M78.517,140.074v3h1v11.5c0,0.827,0.673,1.5,1.5,1.5h11c0.827,0,1.5-0.673,1.5-1.5v-11.5h1v-3H78.517z M92.517,154.574 c0,0.275-0.225,0.5-0.5,0.5h-11c-0.275,0-0.5-0.225-0.5-0.5v-11.5h12V154.574z M93.517,142.074h-14v-1h14V142.074z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropList01);
export default __webpack_public_path__ + "static/media/icon_drop_list-01.7cab7200f3c5938d54b8f4c990a6156a.svg";
export { ForwardRef as ReactComponent };